import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Spin, Table, Input, Button, message, Card } from 'antd';
import _ from 'lodash';

import MUTATION from '../../graphql/mutations/storeCustomerProposedLoansMutation.graphql';
import ALL_QUERY from '../../graphql/queries/getCustomerProposedLoansQuery.graphql';

const { Column } = Table;

class ProposedLoans extends Component {
  state = {
    submittingForm: false,
    proposedLoans: [],
  };

  setValue = (id, key, value) => {
    this.setState({
      proposedLoans: this.state.proposedLoans.map((loan) => {
        const newLoan = loan;
        if (loan.id === id) newLoan[key] = value;
        return newLoan;
      }),
    });
  };

  addNewLoan = () => {
    const newPLs = [...this.state.proposedLoans];

    newPLs.push({
      id: (+new Date()).toString(36),
      product_type: null,
      end_use: null,
      percent_security: null,
    });

    this.setState({
      proposedLoans: newPLs,
    });
  };

  deleteEntry = (id) => {
    this.setState({
      proposedLoans: _.filter(this.state.proposedLoans, (entry) => (entry.id !== id)),
    });
  };

  saveProposedLoans = () => {
    const customer_id = this.props.match.params.id;
    this.setState({
      submittingForm: true,
    });
    this.props.mutate({
      variables: { customer_id, proposed_loans: this.state.proposedLoans },
      update: (cache, { data: { newProposedLoans } }) => {
        const data = cache.readQuery({
          query: ALL_QUERY,
          variables: { customer_id },
        });
        data.proposedLoans = newProposedLoans;
        cache.writeQuery({ query: ALL_QUERY, variables: { customer_id }, data });
      },
    })
      .then(() => {
        this.setState({
          submittingForm: false,
        });
        message.success('Success!');
      })
      .catch((mutateErr) => {
        console.log(mutateErr);
        this.setState({
          submittingForm: false,
        });
        message.error(mutateErr.message);
      });
  };

  render() {
    const { loading } = this.props.data;
    if (loading) {
      return (
        <Spin size="large" />
      );
    }
    const { proposedLoans } = this.state;
    return (
      <Card title="Factsheet - Proposed Loans" bordered={false} className="ec-card">
        <Button onClick={this.addNewLoan}>Add new proposed loan</Button>
        <Table dataSource={proposedLoans} rowKey="id" bordered pagination={false} style={{ marginTop: 20, marginBottom: 20, maxWidth: 800 }} size="medium">
          <Column
            title="Type of Product"
            key="product_type"
            render={(text, record) => (
              <Input
                type="text"
                value={record.product_type}
                onChange={(event) => {
                  this.setValue(record.id, 'product_type', event.target.value);
                }}
              />
            )}
          />
          <Column
            title="End Use"
            key="end_use"
            render={(text, record) => (
              <Input.TextArea
                type="text"
                value={record.end_use}
                onChange={(event) => {
                  this.setValue(record.id, 'end_use', event.target.value);
                }}
              />
            )}
          />
          <Column
            title="% Security Offered"
            key="percent_security"
            width={160}
            render={(text, record) => (
              <Input
                type="text"
                value={record.percent_security}
                onChange={(event) => {
                  this.setValue(record.id, 'percent_security', event.target.value);
                }}
              />
            )}
          />
        </Table>
        <Button type="primary" onClick={this.saveProposedLoans} loading={this.state.submittingForm}>Save</Button>
      </Card>
    );
  }
}

ProposedLoans.getDerivedStateFromProps = (nextProps, prevState) => {
  if (nextProps.data.proposedLoans) {
    const propPL = nextProps.data.proposedLoans;
    if (_.isEqual(prevState.proposedLoans, propPL)) {
      return null;
    }
    return {
      proposedLoans: _.unionBy(propPL.map(({ __typename, ...entry }) => (entry)), prevState.proposedLoans, 'id'),
    };
  }
  return null;
};

ProposedLoans.propTypes = {
  mutate: PropTypes.func.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    proposedLoans: PropTypes.array,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default compose(
  graphql(ALL_QUERY, {
    options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
  }),
  graphql(MUTATION),
)(ProposedLoans);



// WEBPACK FOOTER //
// ./src/pages/factsheet/ProposedLoans.jsx